import React, { ReactElement } from 'react';
import ModalWrapper from '../../components/modals/ModalWrapper';
import ModalHeader from '../../components/modals/ModalHeader';
import Button from '../../components/buttons/Button';
import { IModal } from '../../router/ModalRouter';
import { useTranslation } from 'react-i18next';
import useAppMethods from '../../../../hooks/utility/useAppMethods';

const RestaurantClosedModal = ({ closeModal }: IModal): ReactElement => {
  const { toggleOrderMethodModal } = useAppMethods();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:RestaurantClosed:RestaurantClosedModal' });
  const onScheduleOrderClick = () => {
    toggleOrderMethodModal({ openModal: true });
  };

  return (
    <>
      <ModalWrapper className="mt-4">
        <ModalHeader title="" className="[&_::part(background)]:border-none" onClose={closeModal} />
        <div className="p-4 space-y-md text-center">
          <h2 className="text-md font-semibold">{t('title')}</h2>
          <h3 className="text-brand-text-secondary text-sm font-semibold">{t('subtitle')}</h3>
          <h4 className="text-brand-text-secondary text-sm font-normal !mt-0">{t('description')}</h4>
          <Button title={t('buttons.schedule_order')} className="!mt-8" onClick={onScheduleOrderClick} />
          <Button title={t('buttons.close')} design="tertiary" onClick={closeModal} />
        </div>
      </ModalWrapper>
    </>
  );
};

export default RestaurantClosedModal;
